module.exports = __webpack_public_path__ + "img/cartao-default.dc06ef74.svg";